import _extends from "@babel/runtime/helpers/esm/extends";
export function getMessages(store) {
  return store.state.messageIds.map(id => store.state.messagesById[id]).filter(message => message != null);
}
export function createRuntimeError(code, message, source, recoverable, retryable = false, details) {
  return {
    code,
    message,
    source,
    recoverable,
    retryable,
    details
  };
}
export function getErrorMessage(fallbackMessage, error) {
  return error instanceof Error && error.message ? error.message : fallbackMessage;
}
export function getMessageIdFromError(error) {
  const messageId = error?.details?.messageId;
  return typeof messageId === 'string' && messageId !== '' ? messageId : undefined;
}
export function findAssistantMessageIdsForRetry(store, userMessageId, assistantMessageIdByUserMessageId) {
  const mappedAssistantMessageId = assistantMessageIdByUserMessageId.get(userMessageId);
  if (mappedAssistantMessageId) {
    return [mappedAssistantMessageId];
  }
  const userMessageIndex = store.state.messageIds.indexOf(userMessageId);
  if (userMessageIndex === -1) {
    return [];
  }
  const assistantMessageIds = [];
  for (let index = userMessageIndex + 1; index < store.state.messageIds.length; index += 1) {
    const nextMessageId = store.state.messageIds[index];
    const nextMessage = store.state.messagesById[nextMessageId];
    if (!nextMessage) {
      continue;
    }
    if (nextMessage.role === 'user') {
      break;
    }
    if (nextMessage.role === 'assistant') {
      assistantMessageIds.push(nextMessage.id);
    }
  }
  return assistantMessageIds;
}
export function removeAssistantMessageIds(store, assistantMessageIds, assistantMessageIdByUserMessageId) {
  if (assistantMessageIds.length === 0) {
    return;
  }
  const removedIds = new Set(assistantMessageIds);
  for (const assistantMessageId of assistantMessageIds) {
    store.removeMessage(assistantMessageId);
  }
  for (const [userMessageId, assistantMessageId] of assistantMessageIdByUserMessageId.entries()) {
    if (removedIds.has(assistantMessageId)) {
      assistantMessageIdByUserMessageId.delete(userMessageId);
    }
  }
}
export function applyPresenceUpdate(store, event) {
  for (const conversationId of store.state.conversationIds) {
    const conversation = store.state.conversationsById[conversationId];
    if (!conversation?.participants?.length) {
      continue;
    }
    let didChange = false;
    const participants = conversation.participants.map(participant => {
      if (participant.id !== event.userId || participant.isOnline === event.isOnline) {
        return participant;
      }
      didChange = true;
      return _extends({}, participant, {
        isOnline: event.isOnline
      });
    });
    if (didChange) {
      store.updateConversation(conversationId, {
        participants
      });
    }
  }
}
export function applyReadUpdate(store, event) {
  const conversation = store.state.conversationsById[event.conversationId];
  if (!conversation) {
    return;
  }
  store.updateConversation(event.conversationId, {
    readState: 'read',
    unreadCount: 0
  });
}